import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Seo } from './components/Seo';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Seo data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
      </Routes>
    </BrowserRouter>;
}